import { AuthService } from './../../../Services/auth.service';
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../../../constants';


@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.css']
})
export class LogoutModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;
  @Output() stayEmit = new EventEmitter<any>();
  modalReference: NgbModalRef;
  countdown: number;
  timer: any;
  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'sm'
  };

  constructor(
    private modalService: NgbModal,
    private authService: AuthService) {
  }

  open() {
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    this.startTimer();
  }

  startTimer() {
    this.countdown = Constants.logOutModalTime;
    this.timer = setInterval(async () => {
      this.countdown--;
      if (this.countdown < 0) {
        this.countdown = 0;
        console.log(`App logout at: ${new Date()}`);
        await this.logout();
      }
    }, 1000);
  }

  async logout() {
    await this.authService.logout();
    this.closeModal();
  }

  stay() {
    this.stayEmit.emit();
    this.closeModal();
  }

  closeModal() {
    clearInterval(this.timer);
    this.modalReference.close();
  }
}
